import React from "react";
import cx from "classnames";
import PropTypes from "prop-types";
import { NavLink } from "react-router-dom";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Hidden from "@material-ui/core/Hidden";
import Drawer from "@material-ui/core/Drawer";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";

// @material-ui/icons
import Dashboard from "@material-ui/icons/Dashboard";
import Menu from "@material-ui/icons/Menu";

// core components
import Button from "../components/CustomButtons/Button";

import pagesRoutes from "../routes/pages";// "../components/routes/pages.jsx";// "../routes/pages.jsx";
import logo from "../assets/img/logo-white.svg";
//import pagesHeaderStyle from "../assets/jss/material-dashboard-pro-react/components/pagesHeaderStyle.jsx";
// ##############################
// // // Pages Header styles
// #############################

import {
    container,
    defaultFont,
    primaryColor,
    defaultBoxShadow,
    infoColor,
    successColor,
    warningColor,
    dangerColor,
    boxShadow,
    drawerWidth,
    transition
  } from "src/assets/jss/material-dashboard-pro-react.jsx";
  
  const pagesHeaderStyle = theme => ({
    appBar: {
      backgroundColor: "transparent",
      boxShadow: "none",
      borderBottom: "0",
      marginBottom: "0",
      position: "absolute",
      width: "100%",
      paddingTop: "10px",
      zIndex: "1029",
      color: "#555555",
      border: "0",
      borderRadius: "3px",
      padding: "10px 0",
      transition: "all 150ms ease 0s",
      minHeight: "50px",
      display: "block"
    },
    container: {
      ...container,
      minHeight: "50px"
    },
    flex: {
      flex: 1
    },
    title: {
      ...defaultFont,
      lineHeight: "30px",
      fontSize: "18px",
      borderRadius: "3px",
      textTransform: "none",
      color: "#FFFFFF",
      "&:hover,&:focus": {
        background: "transparent",
        color: "#FFFFFF"
      }
    },
    appResponsive: {
      top: "8px"
    },
    primary: {
      backgroundColor: primaryColor,
      color: "#FFFFFF",
      ...defaultBoxShadow
    },
    info: {
      backgroundColor: infoColor,
      color: "#FFFFFF",
      ...defaultBoxShadow
    },
    success: {
      backgroundColor: successColor,
      color: "#FFFFFF",
      ...defaultBoxShadow
    },
    warning: {
      backgroundColor: warningColor,
      color: "#FFFFFF",
      ...defaultBoxShadow
    },
    danger: {
      backgroundColor: dangerColor,
      color: "#FFFFFF",
      ...defaultBoxShadow
    },
    list: {
      ...defaultFont,
      fontSize: "14px",
      margin: 0,
      marginRight: "-15px",
      paddingLeft: "0",
      listStyle: "none",
      color: "#FFFFFF",
      paddingTop: "0",
      paddingBottom: "0"
    },
    listItem: {
      float: "left",
      position: "relative",
      display: "block",
      width: "auto",
      margin: "0",
      padding: "0",
      [theme.breakpoints.down("sm")]: {
        zIndex: "999",
        width: "100%",
        paddingRight: "15px"
      }
    },
    navLink: {
      color: "#FFFFFF",
      margin: "0 5px",
      paddingTop: "15px",
      paddingBottom: "15px",
      fontWeight: "500",
      fontSize: "12px",
      textTransform: "uppercase",
      borderRadius: "3px",
      lineHeight: "20px",
      position: "relative",
      display: "block",
      padding: "10px 15px",
      textDecoration: "none",
      "&:hover,&:focus": {
        color: "#FFFFFF",
        background: "rgba(200, 200, 200, 0.2)"
      }
    },
    listItemIcon: {
      marginTop: "-3px",
      top: "0px",
      position: "relative",
      marginRight: "3px",
      width: "20px",
      height: "20px",
      verticalAlign: "middle",
      color: "inherit",
      display: "inline-block"
    },
    listItemText: {
      flex: "none",
      padding: "0",
      minWidth: "0",
      margin: 0,
      display: "inline-block",
      position: "relative",
      whiteSpace: "nowrap"
    },
    navLinkActive: {
      backgroundColor: "rgba(255, 255, 255, 0.1)"
    },
    drawerPaper: {
      border: "none",
      bottom: "0",
      transitionProperty: "top, bottom, width",
      transitionDuration: ".2s, .2s, .35s",
      transitionTimingFunction: "linear, linear, ease",
      ...boxShadow,
      width: drawerWidth,
      ...boxShadow,
      position: "fixed",
      display: "block",
      top: "0",
      height: "100vh",
      right: "0",
      left: "auto",
      visibility: "visible",
      overflowY: "visible",
      borderTop: "none",
      textAlign: "left",
      paddingRight: "0px",
      paddingLeft: "0",
      ...transition,
      "&:before,&:after": {
        position: "absolute",
        zIndex: "3",
        width: "100%",
        height: "100%",
        content: '""',
        display: "block",
        top: "0"
      },
      "&:after": {
        background: "#000",
        opacity: ".8"
      }
    },
    sidebarButton: {
      "&,&:hover,&:focus": {
        color: "#FFFFFF"
      },
      top: "-2px"
    },
    logoNormal : {
   
        transition: "all 300ms linear",
        display: "block",
        opacity: "1",
        transform: "translate3d(0px, 0, 0)",
        textTransform: "uppercase",
        padding: "5px 0px",
        fontSize: "18px",
        whiteSpace: "nowrap",
        fontWeight: "400",
        lineHeight: "30px",
        overflow: "hidden",
        "&,&:hover,&:focus": {
          color: "inherit"
        }
      
    },
    center:{'display': 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%'
  }} );
  
interface LoginHeaderProps{
    classes:any;
    color:any;
}
interface LoginHeaderState
{
    open:boolean;
}
class PagesHeader extends React.Component<LoginHeaderProps,LoginHeaderState> {
  constructor(props) {
    super(props);
    this.state = {
      open: false
    };
  }
  handleDrawerToggle = () => {
    this.setState({ open: !this.state.open });
  };
  // verifies if routeName is the one active (in browser input)
  activeRoute(routeName) {
    return this.props['location'].pathname.indexOf(routeName) > -1 ? true : false;
  }
  componentDidUpdate(e) {
    if (e.history.location.pathname !== e.location.pathname) {
      this.setState({ open: false });
    }
  }
  render() {
    const { classes, color } = this.props;
    const appBarClasses = cx({
      [" " + classes[color]]: color
    });
    var list = (
      <List className={classes.list}>
        <ListItem className={classes.listItem}>
          <NavLink to={"/dashboard"} className={classes.navLink}>
            <ListItemIcon className={classes.listItemIcon}>
              <Dashboard />
            </ListItemIcon>
            <ListItemText
              primary={"Dashboard"}
              disableTypography={true}
              className={classes.listItemText}
            />
          </NavLink>
        </ListItem>
        {pagesRoutes.map((prop, key) => {
          if (prop.redirect) {
            return null;
          }
          const navLink =
            classes.navLink +
            cx({
              [" " + classes.navLinkActive]: this.activeRoute(prop.path)
            });
          return (
            <ListItem key={key} className={classes.listItem}>
              <NavLink to={prop.path} className={navLink}>
                <ListItemIcon className={classes.listItemIcon}>
                  <prop.icon />
                </ListItemIcon>
                <ListItemText
                  primary={prop.short}
                  disableTypography={true}
                  className={classes.listItemText}
                />
              </NavLink>
            </ListItem>
          );
        })}
      </List>
    );
    return (
      <AppBar position="static" className={classes.appBar + appBarClasses}>
        <Toolbar className={classes.container}>
          <Hidden smDown>
            <div className={classes.flex}>
            <a href="/" style={{paddingLeft:'25px',paddingRight:'25px',width: '300px'}}  className={classes.logoNormal}>
        <img src={logo} alt="logo"  />
        </a>
            </div>
          </Hidden>
          <Hidden mdUp>
          <div className={classes.center}>
            <a href="/" style={{paddingLeft:'25px',paddingRight:'25px',width: '300px'}}  className={classes.logoNormal}>
        <img src={logo} alt="logo"  />
        </a>
            </div>
          </Hidden>
           </Toolbar>
      </AppBar>
    );
  }
}


//@ts-ignore
PagesHeader.propTypes = {
  classes: PropTypes.object.isRequired,
  color: PropTypes.oneOf(["primary", "info", "success", "warning", "danger"])
};

export default withStyles(pagesHeaderStyle as any)(PagesHeader);



// WEBPACK FOOTER //
// ./src/custom_components/LoginHeader.tsx